"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccrualTable = (function () {
    function AccrualTable() {
        this._rates = [];
    }
    AccrualTable.prototype.addAccrualRate = function (accrualRate, contributionRate, memberType) {
        this._rates[this.key(contributionRate, memberType)] = accrualRate;
    };
    AccrualTable.prototype.accrualRate = function (contributionRate, memberType) {
        return this._rates[this.key(contributionRate, memberType)];
    };
    AccrualTable.prototype.key = function (contributionRate, memberType) {
        return (Math.floor((100 * contributionRate))) + "" + memberType;
    };
    return AccrualTable;
}());
exports.AccrualTable = AccrualTable;
//# sourceMappingURL=AccrualTable.js.map